export class NomEnvironment {
  static Production: string = "Production";
  static Essais: string = "Essais";
  static Formation: string = "Formation";
  static Development: string = "Development";
}
